import { render, staticRenderFns } from "./ElementYearlyPricesTable.vue?vue&type=template&id=404ae4c7"
import script from "./ElementYearlyPricesTable.vue?vue&type=script&lang=js"
export * from "./ElementYearlyPricesTable.vue?vue&type=script&lang=js"
import style0 from "./ElementYearlyPricesTable.vue?vue&type=style&index=0&id=404ae4c7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports